export default __webpack_public_path__ + "locales/ar-SA/ChangePhoneDialog.json?hash=52bfbb7c6dee900008df0fcdcfac0341";